import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      toast.error("could not process request.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-ivory px-8" data-testid="forgot-password-page">
      <div className="max-w-md w-full">
        <Link to="/admin/login" className="editorial-label hover:text-brass">← back to sign-in</Link>
        <span className="editorial-label mt-10 block">studio · reset</span>
        <h1 className="font-serif text-5xl lowercase text-charcoal mt-3 mb-10">forgotten?</h1>

        {sent ? (
          <div className="bg-linen border border-taupe/50 p-8" data-testid="reset-sent">
            <p className="font-serif text-2xl lowercase text-charcoal mb-3">if the email exists, a reset link is on its way.</p>
            <p className="text-sm text-espresso leading-relaxed">check your inbox in the next minute or two. the link expires in 1 hour.</p>
            <p className="editorial-label mt-6">curated with intention.</p>
          </div>
        ) : (
          <form onSubmit={submit}>
            <p className="text-sm text-espresso mb-8 leading-relaxed">enter your studio email — we&apos;ll send you a one-time link to choose a new password.</p>
            <label className="editorial-label">email</label>
            <input
              data-testid="forgot-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-taupe py-3 mt-2 mb-10 focus:outline-none focus:border-brass text-charcoal"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit"
              className="w-full bg-brass hover:bg-espresso text-ivory py-4 text-xs tracking-[0.25em] uppercase transition-colors disabled:opacity-50"
            >
              {loading ? "sending…" : "send reset link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
